<template>
  <div>
    <list
      ref="list"
      unit="进货单"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      @reset-query="$emit('reset-select')"
      :reRowClick="true"
      :get-row-click-func="myRowClick"
      condition="row.Status!=2"
      :pageSizes="[10, 20, 30, 40, 100, 1000]"
      :get-data-func="getDataFunc"
      :summaryMethod="summaryFunc"
      :show-summary="summaryShow"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="供应商名称">
          <supplier  @restaurants='setSupplier' :state='params.SupplierName'/>
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input
            size="mini"
            clearable
            v-model="params.DocNo"
            placeholder="请输入单据编号"
          />
        </el-form-item>
        <el-form-item label="单据状态">
          <el-select
            size="mini"
            v-model="params.Status"
            placeholder="请选择"
            clearable
          >
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据日期">
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        
        <el-form-item label="仓库名称">
          <el-select v-model="params.WarehouseId" placeholder="请选择" clearable>
            <el-option
              v-for="item in wareList"
              :key="item.WarehouseId"
              :label="item.WarehouseName"
              :value="item.WarehouseId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            size="mini"
            clearable
            v-model="params.Remark"
            placeholder="请输入备注"
          />
        </el-form-item>
        <!-- <el-form-item label="开票状态">
          <el-select
            size="mini"
            v-model="params.OutStatus"
            placeholder="请选择"
            clearable
          >
            <el-option label="未开票" :value="0"></el-option>
            <el-option label="部分开票" :value="1"></el-option>
            <el-option label="已开票" :value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="付款状态">
          <el-select
            size="mini"
            v-model="params.ReceiptStatus"
            placeholder="请选择"
            clearable
          >
            <el-option label="未付款" :value="0"></el-option>
            <el-option label="部分付款" :value="1"></el-option>
            <el-option label="已付款" :value="2"></el-option>
          </el-select>
        </el-form-item> -->
      </template>
      <template slot="table">
        <!-- <el-table-column prop="DocNo" label="单据类型"/> -->
        <el-table-column prop="DocNo" label="单据编号" min-width="110px" />
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{ row }">
            {{ row.DocDate.split(" ")[0] }}
          </template>
        </el-table-column>

        <el-table-column prop="SupplierName" label="供应商名称">
        </el-table-column>
        <el-table-column prop="TotalAmount" label="进货单金额" />
        <el-table-column prop="Amount" label="折后金额" />
        <el-table-column prop="DiscountAmount" label="折扣金额" />
        <el-table-column prop="ClerkName" label="业务员" />
        <el-table-column prop="Status" label="单据状态">
          <template slot-scope="{ row }">
            <span v-if="row.Status == 0">草稿</span>
            <span v-else-if="row.Status == 1">未生效</span>
            <span v-else>已生效</span>
          </template>
        </el-table-column>
        <el-table-column prop="OutStatus" label="开票状态">
          <template slot-scope="{ row }">
            <span v-if="row.OutStatus == 0">未开票</span>
            <span v-else-if="row.OutStatus == 1">部分开票</span>
            <span v-else>已开票</span>
          </template>
        </el-table-column>
        <el-table-column prop="PayStatus" label="付款状态">
          <template slot-scope="{ row }">
            <span v-if="row.PayStatus == 0">未付款</span>
            <span v-else-if="row.PayStatus == 1">部分付款</span>
            <span v-else>已付款</span>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="备注" />
        <slot name="column"></slot>
      </template>
    </list>
    <unit-dialog
      ref="unitDialog"
      in-dialog
      selectable
      @select="setUnit"
      title="客户列表"
      :typeList="[1, 2]"
    />
    <warehouse-dialog
      ref="warehouseDialog"
      in-dialog
      selectable
      @select="setWarehouse"
      title="仓库列表"
      :typeList="[1, 2]"
    />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import unitDialog from "@/components/purchase/supplier/archives/listDialog";
import warehouseDialog from "@/components/basicinfo/basic/warehouse/listDialog";
import supplier from "@/components/common/supplier/supplier";
export default {
  mixins: [listMixin],
  components: { list, unitDialog, warehouseDialog,supplier },
  beforeMount() {
    this.cApi.list({ pageSize: 10, pageIndex: 1 }).then((res) => {
      this.cList = res.Data;
      sessionStorage.setItem("cList", JSON.stringify(res.Data));
    });
  },
  mounted() {
       this.dpapi.list({}).then(res => {
        let list=[]
        res.Data.forEach(e => {
          list.push( { "value": e.SupplierName, "Id": e.SupplierId },)
        });
        this.supplierList=list
      })
  },
  data() {
    return {
      api: require("@/api/purchase/stock").default,
      cApi: require("@/api/ba/tradeUnit").default,
      dpapi: require("@/api/ba/tradeUnit").default,
      wareApi: require("@/api/ba/warehouse").default,
      cList: [],
      wareList: [],
      supplierList:[],
      params: {
        DocType: 0,
        DocNo: "",
        SupplierId: null,
        SupplierName: "",        
        DocDateStart: this.$commonJs.getDayOffset(-30),
        DocDateEnd: this.$commonJs.getDayOffset(0),
        Status: null,
        OutStatus: null,
        WarehouseId: null,
        WarehouseName: "",
        Remark:''
        //----------
        // pageIndex: 1,
      },
      summaryShow: false,
      total:null
    };
  },
  mounted() {
    this.wareApi.list({ PageIndex: 1, PageSize: 100 }).then((res) => {
      this.wareList = res.Data;
      sessionStorage.setItem("ware", JSON.stringify(res.Data));
    });
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.list(params).then(res => {
          let times = Math.ceil(res.Count / params.pageSize);
          //判断是否最后一页
          if (times == params.pageIndex) {
            this.api.listTotal(params).then(res => {
              if (res.Code == 0 && res.Data) {
                this.total = res.Data[0];
                this.summaryShow = true;
              } else {
                this.summaryShow = false;
              }
            })
          } else {
            this.summaryShow = false;
          }
          resolve(res);
        })
      })
    },
    summaryFunc(param) {
      const { columns, data } = param;
      var fields = ['Amount','TotalAmount','DiscountAmount']; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find(x => x == column.property);
        if (field) {
          console.log(field, index);
          sums[index] = "";
          if (this.total) {
            sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    setSupplier(data) {
      
      this.params.SupplierId = data.TradeUnitId;
      this.params.SupplierName = data.TradeUnitName;
    },
    handleSelect(item) {
        
        this.params.SupplierName=item.value
        this.params.SupplierId=item.Id
    },
    querySearchAsync(queryString, cb) {
        var supplierList = this.supplierList;
        var results = queryString ? supplierList.filter(this.createStateFilter(queryString)) : supplierList;
        cb(results);
    },
    createStateFilter(queryString) {
        return (state) => {
          if(state.value){
          return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
          }
        };
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.DocExport(this.params).then(() => {
        loading.close();
      });
    },
    myRowClick(row,column,e){
      this.$emit("loading");
      this.api.info(row.DocId).then((res) => {
        this.$emit("setDetails",res.Data.Goods,row);
        this.$emit("loading");
      });
    },
    setWarehouse(e) {
      
      this.params.WarehouseId = e.WarehouseId;
      this.params.WarehouseName = e.WarehouseName;
      // this.data.CustomerType = e.TradeUnitType
    },
    addwarehouse(e) {
      this.$refs.warehouseDialog.open().then((that) => {
        that.getData({});
        that.getTree();
      });
    },
    addUnit(e) {
      this.$refs.unitDialog.open().then((that) => {
        that.getData({});
        that.getTree();
      });
    },
    setUnit(e) {
      
      this.params.SupplierId = e.SupplierId;
      this.params.SupplierName = e.SupplierName;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
